import { withJsonFormsControlProps } from '@jsonforms/react'
import { widgetTester, WidgetSystem } from '../widget/Widget'

export const widgetSystem = {
  tester: widgetTester,
  renderer: withJsonFormsControlProps(WidgetSystem),
}

export const widgetSystemRenderer = {
  widget: {
    tester: widgetTester,
    renderer: withJsonFormsControlProps(WidgetSystem),
  },
}